import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

// Pre-built search index, rebuilt by the scheduled Cloud Function
// (functions/searchIndexFile.js) and rewritten only when lectures change. It is
// served with `no-cache` and an ETag, so the browser keeps it in its HTTP cache
// and repeat visits only revalidate (304) until new lectures are uploaded.
// The token must match SEARCH_INDEX.downloadToken in the function.
export const SEARCH_INDEX_URL =
    'https://firebasestorage.googleapis.com/v0/b/bhakti-granth-seva.firebasestorage.app/o/' +
    `${encodeURIComponent('search/courses-index.json')}?alt=media&token=13279499-7d30-45a9-8ef7-4301ae7e46e8`;

// Old 30-day localStorage copy from the previous search function (it could hold
// other users' progress data), removed from every visitor's browser
const LEGACY_CACHE_KEY = 'coursesData';

const fetchSearchIndex = async () => {
    const response = await fetch(SEARCH_INDEX_URL);
    if (!response.ok) throw new Error(`Search index request failed: ${response.status}`);
    const { data } = await response.json();
    return data;
};

const useFetchDocuments = () => {
    const searchEnabled = !!localStorage.getItem('showCourses');

    useEffect(() => {
        try {
            localStorage.removeItem(LEGACY_CACHE_KEY);
        } catch {
            // Storage unavailable (private mode): nothing to clean up
        }
    }, []);

    const { data, isPending, error } = useQuery({
        queryKey: ['searchIndex'],
        queryFn: fetchSearchIndex,
        enabled: searchEnabled,
    });

    return {
        documents: searchEnabled ? data ?? null : [],
        loadingAllDocs: searchEnabled && isPending,
        error: !!error,
    };
};

export default useFetchDocuments;
